<!--<c-footer>-->
  <div>
    <a href="https://siacaservicios.com/es-VE/#/home" target="_blank">Siaca</a>
    <span> &copy; 2025 Siaca</span>
  </div>
  <div class="ms-auto">
    Powered by
    <a href="https://coreui.io/angular" target="_blank">
      <span> CoreUI for Angular</span>
    </a>
  </div>
<!--</c-footer>-->
